import { getLoadedBotIdFromUrl } from '../../lib/urlService'
import { StateReconciler } from '../../types/redux-persist'

// I need to save previously loaded bot ID for all future instances and calls of reconciler
// since they overwrite the source of truth (localstorage['reconciler:lastLoadedBotId'])
let lastLoadedBotId: string | null | undefined

// This function decorates any existing reconciler to only apply if the currently open botId
// matches the botId which produced the persisted data
//
// This RELIES on the fact that we reload (hence call
// this function and overwrite bot id in localstorage) page every time we select a different bot.
export function sameBotIdOnly<S>(reconciler: StateReconciler<S>): StateReconciler<S> {
  return function resultingReconciler(inboundState, state, reducedState, config) {
    if (lastLoadedBotId === undefined) {
      lastLoadedBotId = window.localStorage.getItem('reconciler:lastLoadedBotId')
    }

    const currentlyLoadedBotId = String(getLoadedBotIdFromUrl())
    window.localStorage.setItem('reconciler:lastLoadedBotId', currentlyLoadedBotId)

    if ([null, 'null', undefined].includes(lastLoadedBotId)) {
      return state
    }

    // Opening a different bot -> do not rehydrate
    if (lastLoadedBotId !== currentlyLoadedBotId) {
      return state
    }

    return reconciler(inboundState, state, reducedState, config)
  }
}
